import { FC, ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './PreQuoteDescription.scss';

import { PreQuoteDescription_shipmentQuote$key } from './__generated__/PreQuoteDescription_shipmentQuote.graphql';

type PreQuoteMessages = Record<string, Record<string, ReactNode | undefined> | undefined>;
const definitions: PreQuoteMessages = {
    PARCEL: {
        STANDARD: (
            <FormattedMessage
                id="shared.delivery.PreQuoteDescription.PARCEL.STANDARD"
                defaultMessage="Delivered by a parcel delivery service such as UPS, FedEx, or DHL. Signature is required at delivery."
            />
        ),
        EXPRESS: (
            <FormattedMessage
                id="shared.delivery.PreQuoteDescription.PARCEL.EXPRESS"
                defaultMessage="Delivered by a parcel delivery service such as UPS, FedEx, or DHL. Signature is required at delivery."
            />
        ),
        MESSENGER: (
            <FormattedMessage
                id="shared.delivery.PreQuoteDescription.PARCEL.MESSENGER"
                defaultMessage="Item collected and hand-delivered via a local courier service. A surcharge may apply for delivery during non-business hours. Signature is required at delivery."
            />
        ),
    },
    WHITE_GLOVE: {
        STANDARD: (
            <FormattedMessage
                id="shared.delivery.PreQuoteDescription.WHITE_GLOVE.STANDARD"
                defaultMessage="Delivered by appointment to the room of your choice.  Includes item collection, packing, shipping, and in-home delivery (unpacking, inspection, and removal of packaging materials). Signature is required at delivery."
            />
        ),
        EXPRESS: (
            <FormattedMessage
                id="shared.delivery.PreQuoteDescription.WHITE_GLOVE.EXPRESS"
                defaultMessage="Delivered by appointment to the room of your choice. Includes item collection, packing, shipping, and in-home delivery (unpacking, inspection, and removal of packaging materials). Signature is required at delivery."
            />
        ),
    },
};

type PreQuoteDescriptionProps = {
    shipmentQuote: PreQuoteDescription_shipmentQuote$key;
};

const PreQuoteDescription: FC<PreQuoteDescriptionProps> = ({ shipmentQuote: shipmentQuoteRef }) => {
    const shipmentQuote = useFragment(
        graphql`
            fragment PreQuoteDescription_shipmentQuote on ShipmentQuote {
                serviceMethod {
                    isFreight
                    serviceType
                    serviceMethodType
                }
            }
        `,
        shipmentQuoteRef
    );

    const serviceType = shipmentQuote?.serviceMethod?.serviceType || '';
    const serviceMethodType = shipmentQuote?.serviceMethod?.serviceMethodType || '';

    return (
        <span className={styles.description}>
            {shipmentQuote?.serviceMethod?.isFreight ? (
                <FormattedMessage
                    id="checkout.PreQuoteDescription.FREIGHT"
                    defaultMessage="Delivered to the first available dry area outside of your house or building (front door, porch, landing area, garage, etc). Includes item collection, packing, shipping and full insurance. Does not include unpacking, inspection, assembly or installation. Signature is required at delivery."
                />
            ) : (
                definitions[serviceType]?.[serviceMethodType]
            )}
        </span>
    );
};

export default PreQuoteDescription;
